// styling
import styles from './styles.module.scss';

// components
import { NavLink } from 'react-router-dom';
import logoPNG from '@assets/tuligalive.jpg';

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className={styles.footer}>
            <div className={styles.inner}>
                <div className={styles.brand}>
                    <img className={styles.logo} src={logoPNG} alt="Tu Liga Live" />
                    <h3>Tu Liga Live</h3>
                    <p className={`text-12 ${styles.tagline}`}>
                        Plataforma para la gestión de la liga: equipos, jugadores, calendario,
                        reportes en vivo, estadísticas y planilla digital, todo en un solo lugar.
                    </p>
                </div>

                <div className={styles.col}>
                    <h4 className={styles.col_title}>Contacto</h4>
                    <a className={`text-12 ${styles.row_link}`} href="mailto:estupinanservicios@gmail.com">
                        <i className="icon icon-envelope" />
                        estupinanservicios@gmail.com
                    </a>
                    <a
                        className={`text-12 ${styles.row_link}`}
                        href="https://wa.me/573161098069"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i className="icon icon-phone-solid" />
                        WhatsApp 316 109 8069
                    </a>
                    <a
                        className={`text-12 ${styles.row_link}`}
                        href="https://tuligalive.co"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i className="icon icon-house" />
                        tuligalive.co
                    </a>
                </div>

                <div className={styles.col}>
                    <h4 className={styles.col_title}>Enlaces</h4>
                    <NavLink className={`text-12 ${styles.row_link}`} to="/schedule">
                        <i className="icon icon-calendar" />
                        Calendario
                    </NavLink>
                    <a
                        className={`text-12 ${styles.row_link}`}
                        href="https://api.futbolasociadoasoprof.com/static/reglamento.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i className="icon icon-pdf" />
                        Reglamento
                    </a>
                    <a
                        className={`text-12 ${styles.row_link}`}
                        href="https://futbolasociadoasoprof.com/statistics"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i className="icon icon-users" />
                        Estadísticas
                    </a>
                </div>
            </div>

            <div className={`text-12 ${styles.bottom}`}>
                © {year} Tu Liga Live · tuligalive.co
            </div>
        </footer>
    )
}

export default Footer
